/**
 * @generated SignedSource<<d98eec37cfca748a729164d1fbacd9a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateHospitalInput = {
  name: string;
  timezone?: string | null | undefined;
  uuid?: string | null | undefined;
};
export type CreateHospitalModalMutation$variables = {
  input: CreateHospitalInput;
};
export type CreateHospitalModalMutation$data = {
  readonly createHospital: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly timezone: string | null | undefined;
  } | null | undefined;
};
export type CreateHospitalModalMutation = {
  response: CreateHospitalModalMutation$data;
  variables: CreateHospitalModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Hospital",
    "kind": "LinkedField",
    "name": "createHospital",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timezone",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateHospitalModalMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateHospitalModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3dfba8e099ef4506949d24e5d01a3b9",
    "id": null,
    "metadata": {},
    "name": "CreateHospitalModalMutation",
    "operationKind": "mutation",
    "text": "mutation CreateHospitalModalMutation(\n  $input: CreateHospitalInput!\n) {\n  createHospital(input: $input) {\n    id\n    name\n    timezone\n  }\n}\n"
  }
};
})();

(node as any).hash = "39d752b1453b53aaea8915042b22255b";

export default node;
